export default __webpack_public_path__ + "static/media/goods3.9304127a.gif";